import ROUTE_NAMES from "@/app/exercise/router/router-const";
export default [
  {
    path: "exams",
    name: ROUTE_NAMES.EXAMS,
    component: () =>
      import("@/app/exercise/modules/exams/ExamsPage.vue")
  }
];
